module.exports = __webpack_public_path__ + "assets/img/logo.85f03b1f.png";